import { Image, ImageProps } from 'antd';
import React from 'react';

export interface FillImageProps extends ImageProps {
  extraClass?: string;
}

const FillImage: React.FC<FillImageProps> = (props) => {
  return (
    <>
      <Image
        preview={false}
        width={'100%'}
        height={'100%'}
        {...props}
        style={{ position: 'absolute', inset: 0 }}
        rootClassName={`absolute inset-0 ${props.extraClass}`}
      />
    </>
  );
};

export default FillImage;
